import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  deleteKnowledgebaseOverridesAction,
  listKnowledgebaseOverridesAction,
} from '../../../../../store/actions/knowledgebaseoverrides';

const DeleteKnowledgeBaseOverrides = ({
  isOpen,
  setIsOpen,
  filterValue,
  knowledgebaseId,
  orgUuid,
}) => {
  const dispatch = useDispatch();
  const { knowledgebaseOverridesItem } = useSelector(
    (state) => state?.knowledgebaseState
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDelete = async () => {
    if (!orgUuid) {
      console.error('Organization UUID is required');
      return;
    }

    if (knowledgebaseOverridesItem || knowledgebaseId) {
      dispatch(
        deleteKnowledgebaseOverridesAction(orgUuid, knowledgebaseId, () => {
          handleClose();
          dispatch(listKnowledgebaseOverridesAction(orgUuid, filterValue));
        })
      );
    }
  };

  return (
    <Modal
      title="Delete Knowledge Base Override"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={400}
    >
      <div className="flex flex-col items-center py-4">
        <ExclamationCircleOutlined
          style={{ fontSize: '48px', color: '#ff4d4f', marginBottom: '16px' }}
        />
        <h3 className="text-lg font-medium mb-2">Confirm Deletion</h3>
        <p className="text-center mb-6">
          Are you sure you want to delete the knowledge base override? This
          action cannot be undone.
        </p>
        <div className="flex justify-end w-full">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button
            type="primary"
            danger
            onClick={handleDelete}
            disabled={!orgUuid}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteKnowledgeBaseOverrides;
